const Index = r => require.ensure([], () => r(require('./Index')), 'student-share')
const InviteRegistered = r => require.ensure([], () => r(require('./InviteRegistered')), 'student-share-InviteRegistered')
const ConsultantDetails = r => require.ensure([], () => r(require('./ConsultantDetails')), 'student-share-ConsultantDetails')
const ShareArticleDetails = r => require.ensure([], () => r(require('./ShareArticleDetails')), 'student-share-ShareArticleDetails')
const ArticleDetails = r => require.ensure([], () => r(require('./ArticleDetails')), 'student-share-ArticleDetails')
const LessonDetails = r => require.ensure([], () => r(require('./LessonDetails')), 'student-share-LessonDetails')
const LessonDetailsCatalog = r => require.ensure([], () => r(require('./LessonDetailsChildren/Catalog')), 'student-share-LessonDetailsChildren')
const LessonDetailsGeneral = r => require.ensure([], () => r(require('./LessonDetailsChildren/General')), 'student-share-LessonDetailsChildren')
const LessonDetailsGrade = r => require.ensure([], () => r(require('./LessonDetailsChildren/Grade')), 'student-share-LessonDetailsChildren')
const ShareSuccessCaseDetails = r => require.ensure([], () => r(require('./ShareSuccessCaseDetails')), 'student-share-ShareSuccessCaseDetails')
const SuccessCaseDetails = r => require.ensure([], () => r(require('./SuccessCaseDetails')), 'student-share-SuccessCaseDetails')
const Protocol = r => require.ensure([], () => r(require('./Protocol')), 'student-share-Protocol')
const ShareAcademyApply = r => require.ensure([], () => r(require('./ShareAcademyApply')), 'student-share-ShareAcademyApply')
const ShareVideo = r => require.ensure([], () => r(require('./ShareVideo')), 'student-share-video')
const InviteFriends = r => require.ensure([], () => r(require('./InviteFriends')), 'student-share-invite-friends')
const MyAccount = r => require.ensure([], () => r(require('./MyAccount')), 'student-share-invite-friends')
const MyInvitationList = r => require.ensure([], () => r(require('./MyInvitationList')), 'student-share-invite-friends')
const InvitationDetails = r => require.ensure([], () => r(require('./InvitationDetails')), 'student-share-invite-friends')

const SpecifyConsultant = r => require.ensure([], () => r(require('./SpecifyConsultant')), 'student-share-invite-friends')
const ShareConsultantDetails = r => require.ensure([], () => r(require('./ShareConsultantDetails')), 'consultant-details-student-share')
const ShareNewConsultantDetails = r => require.ensure([], () => r(require('./ShareNewConsultantDetails')), 'consultant-new-details-student-share')
const InvitationDownload = r => require.ensure([], () => r(require('./InvitationDownload')), 'student-share-InvitationDownload')
const DirectBroadcast = r => require.ensure([], () => r(require('./DirectBroadcast')), 'student-share-DirectBroadcast')
const OrderDetailsModel = r => require.ensure([], () => r(require('./OrderDetailsModel')), 'student-UnpaidOrderDetails')
const UnpaidOrderDetails = r => require.ensure([], () => r(require('./UnpaidOrderDetails')), 'student-UnpaidOrderDetails')
const AreadyPaidOrderDetails = r => require.ensure([], () => r(require('./AreadyPaidOrderDetails')), 'student-AreadyPaidOrderDetails')
const GoodsDetails = r => require.ensure([], () => r(require('./GoodsDetails')), 'student-goods-details')
const CourseDetails = r => require.ensure([], () => r(require('./CourseDetails')), 'student-goods-details')
const PayRecode = r => require.ensure([], () => r(require('./PayRecode')), 'student-pay-recode')
const Privacy = r => require.ensure([], () => r(require('./Privacy')), 'privacy')
const StudentCoach = r => require.ensure([], () => r(require('./StudentCoach')), 'student-coach')

export default {//
  path: '/student',
  component: Index,
  children: [
    {// http://localhost:8080/#/student/pay-recode?orderCode=T120309300924100632&resourceId=2030930&unPayNum=14000&payedNum=0&type=1
      path: 'pay-recode',
      name: 'PayRecode',
      component: PayRecode
    },
    {// cid=G002212&fid=G003125&r=54f6ee8e9829ba2560d7e2722e2e7362
      path: 'consultant-details',
      name: 'ConsultantDetails',
      component: ConsultantDetails
    },
    {// trainId=6207&f=11636&r=1381ca49e59b61f1a842a16649b8de27
      path: 'lesson-details',
      name: '',
      component: LessonDetails,
      children: [
        {
          path: '',
          redirect: 'general',
          meta: {
            isLogin: true,
            title: '课程详情'
          }
        },
        {
          path: 'general',
          name: 'sGeneral',
          component: LessonDetailsGeneral,
          meta: {
            header: true,
            footer: true,
            isLogin: true,
            title: '课程详情'
          }
        },
        {
          path: 'catalog',
          name: 'sCatalog',
          component: LessonDetailsCatalog,
          meta: {
            header: true,
            footer: true,
            isLogin: true,
            title: '课程详情'
          }
        },
        {
          path: 'grade',
          name: 'sGrade',
          component: LessonDetailsGrade,
          meta: {
            header: true,
            footer: true,
            isLogin: true,
            title: '课程详情'
          }
        }
      ]
    },
    {// caseid=3097&cid=G003125&random=59f73db7ce3145be37a573f2a263de60
      path: 'share-success-case-details',
      name: 'ShareSuccessCaseDetails',
      component: ShareSuccessCaseDetails
    },
    {// caseid=3097&cid=G003125&random=59f73db7ce3145be37a573f2a263de60
      path: 'success-case-details',
      name: 'studentSuccessCaseDetails',
      component: SuccessCaseDetails
    },
    {// articleId=25725&cid=G003125&random=4eea91f62c45cf4845bd9db04ea7a565
      path: 'share-article-details',
      name: 'ShareArticleDetails',
      component: ShareArticleDetails
    },
    {// articleId=25725&cid=G003125&random=4eea91f62c45cf4845bd9db04ea7a565
      path: 'article-details',
      name: 'studentArticleDetails',
      component: ArticleDetails
    },
    {
      path: 'invite-registered',
      name: 'sInviteRegistered',
      component: InviteRegistered
    },
    {
      path: 'protocol',
      name: 'Protocol',
      component: Protocol
    },
    {
      path: 'share-academy-apply',
      name: 'ShareAcademyApply',
      component: ShareAcademyApply
    },
    {
      path: 'share-video',
      name: 'ShareVideo',
      component: ShareVideo
    },
    // -邀请好友页面 http://0.0.0.0:8080/#/student/invite-friends?userId=NG9EGQ181WF6DK08&isApp=false
    {
      path: 'invite-friends',
      name: 'InviteFriends',
      component: InviteFriends
    },
    {
      path: 'my-account',
      name: 'MyAccount',
      component: MyAccount
    },
    {
      path: 'my-invitation-list',
      name: 'MyInvitationList',
      component: MyInvitationList
    },
    {
      path: 'invitation-details',
      name: 'InvitationDetails',
      component: InvitationDetails
    },
    {
      path: 'specify-consultant',
      name: 'SpecifyConsultant',
      component: SpecifyConsultant
    },
    {
      path: 'share-consultant-details',
      name: 'ShareConsultantDetails',
      component: ShareConsultantDetails
    },
    {
      path: 'share-new-consultant-details',
      name: 'ShareNewConsultantDetails',
      component: ShareNewConsultantDetails,
      meta: {
        title: '学生端顾问详情'
      }
    },
    {
      path: 'invitation-download',
      name: 'InvitationDownload',
      component: InvitationDownload
    },
    {
      path: 'direct-broadcast',
      name: 'DirectBroadcast',
      component: DirectBroadcast
    },
    {
      path: 'order-details-model',
      name: 'OrderDetailsModel',
      component: OrderDetailsModel
    },
    {
      path: 'unpaid-order-details',
      name: 'UnpaidOrderDetails',
      component: UnpaidOrderDetails
    },
    {
      path: 'aready-paid-order-details',
      name: 'AreadyPaidOrderDetails',
      component: AreadyPaidOrderDetails
    },
    {
      path: 'goods-details',
      name: 'sGoodsDetails',
      component: GoodsDetails
    },
    {
      path: 'course-details',
      name: 'courseDetails',
      component: CourseDetails
    },
    {
      path: 'privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: 'student-coach',
      name: 'StudentCoach',
      component: StudentCoach
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/student/router.js